import { BrowseViewResponseDto, ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import env from '@/env';
import { CostList } from '../types';

export const getCostLists = async ({
  page,
  pageSize,
  search,
  lang,
}: {
  page: number;
  pageSize: number;
  search: string;
  lang: string;
}): Promise<BrowseViewResponseDto<CostList>> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/cost-lists?${new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      search: search.toString(),
      lang: lang,
    })}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as BrowseViewResponseDto<CostList>;
  return response;
};
